import React from "react";
import NoData from "../../shared/NoData";
import { capitalize } from "../../utils/wordUtils";

type TableDetailProps = {
  property: string;
  value: string | number;
  index: string | number;
};

const TableDetail = ({ property, value, index }: TableDetailProps) => {
  return (
    <div
      className={`${
        +index % 2 === 0 && "bg-gray-50"
      } px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6`}
    >
      <dt
        className={`text-sm font-bold "text-gray-500"
    `}
      >
        {capitalize(String(property))}
      </dt>
      <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
        {value || <NoData></NoData>}
      </dd>
    </div>
  );
};

export default TableDetail;
